export const statusDivider = {
	status: 'You closed the chat',
};
